import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={COMPANY.logo} alt="KSPB" className="h-12 w-12 rounded object-contain bg-white/5 p-1" />
            <div>
              <div className="font-heading text-white font-bold text-lg">KSPB</div>
              <div className="text-[10px] tracking-widest uppercase text-slate-400">Enterprises LLP</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            Smart GPS tracking solutions for individuals, fleets, schools, and logistics businesses across India.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-white font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#FF6D00] transition-colors">About Us</Link></li>
            <li><Link to="/products" className="hover:text-[#FF6D00] transition-colors">Products</Link></li>
            <li><Link to="/services" className="hover:text-[#FF6D00] transition-colors">Services</Link></li>
            <li><Link to="/industries" className="hover:text-[#FF6D00] transition-colors">Industries</Link></li>
            <li><Link to="/pricing" className="hover:text-[#FF6D00] transition-colors">Pricing</Link></li>
            <li><Link to="/faq" className="hover:text-[#FF6D00] transition-colors">FAQs</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white font-semibold mb-4">Policies</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/policy/privacy" className="hover:text-[#FF6D00] transition-colors">Privacy Policy</Link></li>
            <li><Link to="/policy/terms" className="hover:text-[#FF6D00] transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/policy/refund" className="hover:text-[#FF6D00] transition-colors">Refund & Cancellation</Link></li>
            <li><Link to="/policy/shipping" className="hover:text-[#FF6D00] transition-colors">Shipping & Delivery</Link></li>
            <li><Link to="/track-order" className="hover:text-[#FF6D00] transition-colors">Track Order</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white font-semibold mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-[#FF6D00]" />
              <a href={`tel:${COMPANY.phone}`} className="hover:text-white">{COMPANY.phoneDisplay}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-[#FF6D00]" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all">{COMPANY.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#FF6D00]" />
              <span>{COMPANY.location}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} KSPB Enterprises LLP. All rights reserved.</div>
          <div>Secure Payments • GST Compliant • Made in India</div>
        </div>
      </div>
    </footer>
  );
}
